// POC toggle for the admin portal restructuring exploration.
//   1 → POC 1: three separate admin portals (Core + LMS + Admission).
//   2 → POC 2: single unified admin portal with peer LMS / Admission sections.
//
// Backed by localStorage so the user-menu toggle can flip variants at runtime.
// Route registration runs at app boot; toggling requires a page reload to
// pick up new routes (handled by the user-menu click handler).

export const ADMIN_PORTAL_POC = {
  THREE_PORTALS: 1,
  UNIFIED_PORTAL: 2,
};

const STORAGE_KEY = "admin_portal_poc_variant";
const DEFAULT_VARIANT = ADMIN_PORTAL_POC.THREE_PORTALS;

const isValidVariant = value =>
  value === ADMIN_PORTAL_POC.THREE_PORTALS ||
  value === ADMIN_PORTAL_POC.UNIFIED_PORTAL;

export const getAdminPortalPocVariant = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return DEFAULT_VARIANT;
  }
  const raw = window.localStorage.getItem(STORAGE_KEY);
  const parsed = Number(raw);
  return isValidVariant(parsed) ? parsed : DEFAULT_VARIANT;
};

export const setAdminPortalPocVariant = variant => {
  if (typeof window === "undefined" || !window.localStorage) return;
  if (!isValidVariant(variant)) return;
  window.localStorage.setItem(STORAGE_KEY, String(variant));
};

// Module-evaluated snapshot for code that reads at app boot (route
// registration files in particular). Render-time call sites should call
// `getAdminPortalPocVariant()` so the value stays accurate after the user
// menu toggles + reloads.
export const ADMIN_PORTAL_POC_VARIANT = getAdminPortalPocVariant();
